import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import moment from 'moment';
import { replace, isNil } from 'lodash';
import ListPagination from '../../../../common/components/Form/ListPagination';
import { onTextFilterNosaving as onTextFilter } from '../../../../common/components/CommonTableDataFilter/CommonTableDataFilter';
import { iotOnDateFormat } from '../../../../common/services/ValidationRules';

export const packagesListDefaultSortedObj = { id: 'packageName', desc: false };

class ChargerPackagesComponent extends React.Component {
  constructor(props) {
    super(props);
    this.tableComponent = null;
  }

  getColumns = () => [
    {
      Header: 'Package Name',
      id: 'packageName',
      accessor: 'packageName',
      className: 'break-string',
      minWidth: 100,
      Filter: onTextFilter,
    },
    {
      Header: 'Version',
      id: 'version',
      accessor: 'version',
      className: 'break-string',
      minWidth: 100,
      Cell: ({ value }) => replace(value, / /g, '\u00A0'),
      Filter: onTextFilter,
    },
    {
      Header: 'Last Updated Date/Time (UTC)',
      id: 'updatedAt',
      accessor: 'updatedAt',
      className: 'break-string',
      minWidth: 100,
      Cell: ({ value }) => (value ? moment.utc(value).format(iotOnDateFormat) : ''),
      filterable: false,
      sortable: false,
    },
  ];

  componentDidMount() {
    const { chargerUuid } = this.props;

    this.props.getChargerPackages(chargerUuid);
  }

  saveRef = (ref) => {
    this.setState({ tableComponent: ref });
  };

  handleFilterChange = (column, value) => {
    if (this.state.tableComponent) this.props.setTotalCount(this.state.tableComponent.state.sortedData.length);
  };

  filterMethod = (filter, row) => {
    const id = filter.id;
    const rowValue = row[id];
    const hasValue = !isNil(rowValue) && !isNil(filter.value);

    if (hasValue) {
      return rowValue.toLowerCase().includes(filter.value.toLowerCase().trim());
    }

    return true;
  };

  render() {
    const { packages, totalCount } = this.props;

    return (
      <div data-activetab="packages" className="create-edit-static-list">
        <ReactTable
          className="sticky -highlight"
          loading={this.props.isFetching}
          totalCount={totalCount}
          data={packages}
          filterable
          defaultSorted={[packagesListDefaultSortedObj]}
          columns={this.getColumns()}
          PaginationComponent={ListPagination}
          ref={this.saveRef}
          onFilteredChange={this.handleFilterChange}
          defaultFilterMethod={this.filterMethod}
        />
      </div>
    );
  }
}

ChargerPackagesComponent.propTypes = {
  packages: PropTypes.array,
  totalCount: PropTypes.number,
  getChargerPackages: PropTypes.func,
};

export default ChargerPackagesComponent;
